import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";
import {QuantityUnit} from "@/model/QuantityUnit";

export class Quantity implements Serializable {
    index: number;
    value: number;
    unit: QuantityUnit | string;

    constructor(value?: number, unit?: QuantityUnit | string, index?: number) {
        this.value = value ?? 0;
        this.unit = unit ?? null;
        this.index = index ?? 0;
    }

    fromJSON(rawObject: any) {
        SerializationHelper.copyNonExcludedProperties(this, rawObject, []);
    }
}
